<template>
  <div id="percentageChart">
    <PieChart :chartData="chartData" :title="'Grant Funds Allocation'"/>
  </div>
</template>
<script>
import PieChart from './PieChartPercent'
export default {
  data() {
    return {
      chartData: {
        labels: ['Demolition', 'Program Administration', 'Special Projects', 'Rehabs & Side Lot Program Support', 'Misc'],
        datasets: [
          {
            label: '%',
            backgroundColor: ['hsl(163, 40%, 70%)', 'hsl(207, 47%, 65%)', 'hsl(11, 71%, 60%)', 'hsl(39, 100%, 70%)', 'hsl(23, 81%, 60%)', 'hsl(274, 36%, 70%)', '#333', 'eee'],
            data: [69.3, 9, 13.2, 5.3, 3.2]
          }
        ]
      }
    }
  },
  components: { PieChart }
}
</script>



// WEBPACK FOOTER //
// src/components/AllocationsPie.vue